"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    imagesSize: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    file: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    /** 获取文件 状态
     * @param { Object } file 文件对象
     * @return { String } 文件 状态
     */
    getFileStatus: function getFileStatus(file) {
      if (file !== null && file !== void 0 && file.response) {
        var _file$response;
        var code = file === null || file === void 0 || (_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.code;
        if (code === 200) return 'success';else return 'error';
      } else if (file.status) return file.status;
      return '';
    },
    /** 获取文件 name
     * @param { Object } file 文件对象
     * @return { String } 文件 name
     */
    getFileName: function getFileName(file) {
      var _ref, _file$url, _file$response2, _ref2, _file$name, _file$response3;
      var url = (_ref = (_file$url = file === null || file === void 0 ? void 0 : file.url) !== null && _file$url !== void 0 ? _file$url : file === null || file === void 0 || (_file$response2 = file.response) === null || _file$response2 === void 0 || (_file$response2 = _file$response2.data) === null || _file$response2 === void 0 ? void 0 : _file$response2.url) !== null && _ref !== void 0 ? _ref : '';
      return (_ref2 = (_file$name = file === null || file === void 0 ? void 0 : file.name) !== null && _file$name !== void 0 ? _file$name : file === null || file === void 0 || (_file$response3 = file.response) === null || _file$response3 === void 0 || (_file$response3 = _file$response3.data) === null || _file$response3 === void 0 ? void 0 : _file$response3.name) !== null && _ref2 !== void 0 ? _ref2 : url === null || url === void 0 ? void 0 : url.replace(/(.*\/)*([^.]+)/ig, '$2');
    },
    /** 获取文件 URL
     * @description: 获取文件URL
     * @param { Object } file 文件对象
     * @return { String } 文件URL
     */
    getFileUrl: function getFileUrl(file) {
      var _ref3, _ref4, _file$response$url, _file$response4;
      return (_ref3 = (_ref4 = (_file$response$url = file === null || file === void 0 || (_file$response4 = file.response) === null || _file$response4 === void 0 ? void 0 : _file$response4.url) !== null && _file$response$url !== void 0 ? _file$response$url : file === null || file === void 0 ? void 0 : file.url) !== null && _ref4 !== void 0 ? _ref4 : file === null || file === void 0 ? void 0 : file.src) !== null && _ref3 !== void 0 ? _ref3 : typeof file === 'string' ? file : '';
    },
    /** 获取文件 type
     * @param { Object } file 文件对象
     * @return { String } 文件 type
     */
    getFileType: function getFileType(file) {
      var _file$raw;
      return file === null || file === void 0 || (_file$raw = file.raw) === null || _file$raw === void 0 ? void 0 : _file$raw.type;
    },
    /** 获取文件 图标类名
     * @param { Object } file 文件对象
     * @return { String } 文件 图标类名
     */
    getIconCalss: function getIconCalss(file) {
      this.$$getFileType(file.url);
      var a = this.getFileType(file);
      var b = 'el-icon-';
      var c;

      // console.log(a)
      if (a !== null && a !== void 0 && a.includes('image')) c = 'picture-outline';else if (a !== null && a !== void 0 && a.includes('video')) c = 'film';else if (a !== null && a !== void 0 && a.includes('text')) c = 'document';else c = 'files';
      return b + c;
    },
    /** 放大图片文件
     * @param { Object } file 文件对象
     * @return { void }
     */
    fullImageFile: function fullImageFile() {
      this.$$listenersEmit.apply(this, ['full-image'].concat(Array.prototype.slice.call(arguments)));
    } /* file */,
    /** 下载文件
     * @param { Object } file 文件对象
     * @return { void }
     */
    downloadFile: function downloadFile(file) {
      var url = this.getFileUrl(file);
      if (!url) this.$message.warning('无法获取下载链接！');else {
        var a = document.createElement('a');
        a.style.cssText += ';display: none;';
        a.href = url;
        a.setAttribute('download', this.getFileName(file));
        a.click();
        this.$message.success('正在准备下载文件，请稍后。（ 如果未能下载文件请重新下载试试 ）');
      }
    },
    /** 删除文件
     * @param { Object } file 文件对象
     * @return { void }
     */
    deleteFile: function deleteFile() {
      this.$$listenersEmit.apply(this, ['on-remove'].concat(Array.prototype.slice.call(arguments)));
    } /* file */
  }
};